import React from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";

const url = `https://tinkergarten.wistia.com/medias`;
const config = {
  wistia: {
    videoFoam: true,
    playerColor: "#DAF1F9",
    playButton: true,
  },
};

const TgVideoPlayer = ({ videoId, ...props }) => (
  <div className="player-wrapper">
    <ReactPlayer
      className="react-player"
      controls={true}
      url={`${url}/${videoId}`}
      config={config}
      width="100%"
      height="100%"
      style={{ borderRadius: 10, overflow: "clip" }}
      {...props}
    />
  </div>
);

TgVideoPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
};

export default TgVideoPlayer;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/TgVideoPlayer/index.jsx